import i18n from '@/shared/i18n';
import BaseModel from "@/core/components/input-widget/BaseModel";

export default class VendorChargeSearch extends BaseModel {
  name = null;
  is_active = null;
  level = null;
  applies_to = null;
  lot_statuses = null;
  calculate_from = [];
  is_aggregate = null;
  is_taxable = null;
  is_tax_inclusive = null;
  tax_rate_start = null;
  tax_rate_end = null;

  rules = {};

  attributeLabels = {
    name: i18n.t('Name'),
    is_active: i18n.t('Is Active'),
    level: i18n.t('Level'),
    applies_to: i18n.t('Applies To'),
    lot_statuses: i18n.t('Lot Status'),
    calculate_from: i18n.t('Calculate From'),
    is_aggregate: i18n.t('Is Aggregate'),
    is_taxable: i18n.t('Is Taxable'),
    is_tax_inclusive: i18n.t('Is Tax Inclusive'),
    tax_rate_start: i18n.t('Tax Rate From'),
    tax_rate_end: i18n.t('Tax Rate To'),
  };

  attributePlaceholders = this.attributeLabels;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  toJSON() {
    let data = super.toJSON();
    data.calculate_from = data.calculate_from.join(',')
    return data;
  }
}
